/**
 * Colour-coded pill for a code_redeem_attempts outcome (OCP-514). Shared by
 * the per-account RedeemAttemptsCard + the global AdminRedeemAttemptsPage so
 * the outcome vocabulary reads identically on both surfaces.
 *
 *  - success                       -> emerald (all good)
 *  - error / provision_failed      -> red (the systemic-problem signal)
 *  - unknown / expired / exhausted / malformed / rejected_duplicate /
 *    rejected_input -> amber (a rejected redeem; OCP-564: user outcomes are
 *    never red, they are not the systemic signal)
 */
const RED = new Set(['error', 'provision_failed']);

export function RedeemOutcomePill({ outcome }: { outcome: string }) {
  const cls =
    outcome === 'success'
      ? 'border-emerald-200 dark:border-emerald-800 bg-emerald-50 dark:bg-emerald-900/30 text-emerald-800 dark:text-emerald-300'
      : RED.has(outcome)
        ? 'border-red-200 dark:border-red-800 bg-red-50 dark:bg-red-900/30 text-red-700 dark:text-red-300'
        : 'border-amber-200 dark:border-amber-800 bg-amber-50 dark:bg-amber-900/30 text-amber-800 dark:text-amber-200';
  return <span className={`rounded border px-2 py-0.5 text-xs ${cls}`}>{outcome}</span>;
}
